import * as yup from 'yup';
import { cpf as validateCpf } from 'cpf-cnpj-validator';

const schema = yup.object().shape({
  nome: yup.string().required('Nome completo deve ser preenchido'),
  telefone: yup.string().required('O telefone deve ser preenchido'),
  cpf: yup
    .string()
    .nullable()
    .transform((v) => (v === '' ? null : v))
    .test('validate', 'CPF inválido', (value) => {
      if (!value) return true;
      const onlyNumbers = value.replace(/\D/g, '');
      return onlyNumbers.length === 11 && validateCpf.isValid(onlyNumbers);
    }),
});

export default schema;
